import { useId } from 'react';
import { DashboardPageFormField } from '@shigo-ui/dashboard-ui';
import { AutocompleteMultiSelect } from '@shigo-ui/ui';

import { dashboardT } from '../../../../lib/messages';
import type { NamedTargetingEntity, TargetingFormValue } from '../../model';
import type { TargetingFormUpdate } from './TargetingForm.types';
import { InclusionToggle } from './InclusionToggle';
import { TargetingSection } from './TargetingSection';
import { TargetingTextarea } from './TargetingTextarea/TargetingTextarea';

export function PlatformsTargetingSection({
  platforms,
  updateField,
  value,
}: {
  platforms: NamedTargetingEntity[];
  updateField: TargetingFormUpdate;
  value: TargetingFormValue;
}) {
  return (
    <TargetingSection
      title={dashboardT('integrations.targeting.platforms')}
      action={
        <InclusionToggle
          included={!value.platformsExcluded}
          onIncludedChange={(included) => {
            updateField('platformsExcluded', !included);
          }}
        />
      }
    >
      <AutocompleteMultiSelect
        label={dashboardT('integrations.targeting.platforms')}
        options={platforms.map(({ id, name }) => ({ id, label: name }))}
        value={value.platformIds}
        maxResults={platforms.length}
        onValueChange={(ids) => {
          updateField('platformIds', ids);
        }}
      />
    </TargetingSection>
  );
}

export function PmpDealIdsTargetingSection({
  updateField,
  value,
}: {
  updateField: TargetingFormUpdate;
  value: TargetingFormValue;
}) {
  const fieldId = useId();

  return (
    <TargetingSection
      title={dashboardT('integrations.targeting.pmpDealIds')}
      action={
        <InclusionToggle
          included={!value.pmpDealIdsExcluded}
          onIncludedChange={(included) => {
            updateField('pmpDealIdsExcluded', !included);
          }}
        />
      }
    >
      <DashboardPageFormField
        label={dashboardT('integrations.targeting.pmpDealIds')}
        htmlFor={fieldId}
      >
        <TargetingTextarea
          id={fieldId}
          copyLabel={dashboardT('integrations.targeting.pmpDealIds')}
          value={value.pmpDealIdsText}
          onChange={(event) => {
            updateField('pmpDealIdsText', event.target.value);
          }}
        />
      </DashboardPageFormField>
    </TargetingSection>
  );
}
